// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-ProductType-__ProductTypePage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProductType/ProductTypePage.module.css
// module id = 1240
// module chunks = 1